import { render, staticRenderFns } from "./ticketNotice.vue?vue&type=template&id=30994e98&scoped=true&"
import script from "./ticketNotice.vue?vue&type=script&lang=js&"
export * from "./ticketNotice.vue?vue&type=script&lang=js&"
import style0 from "./ticketNotice.vue?vue&type=style&index=0&id=30994e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30994e98",
  null
  
)

export default component.exports